import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { COMMUNICATION_QUERY } from "../../api";
import { Communication } from "../types";
export const useCommunication = (
  communicationId: string | undefined | null
) => {
  const { data, loading } = useQuery(COMMUNICATION_QUERY, {
    variables: { id: communicationId ?? "" },
    skip: !communicationId,
  });

  return useMemo<{
    communication: Communication | null | undefined;
    loading: boolean;
  }>(
    () => ({ communication: data?.communication, loading }),
    [data?.communication, loading]
  );
};
